import { useState } from "react";
import {
  IconButton
} from "@mui/material";
import { MdVisibility, MdDownload } from "react-icons/md";
import * as XLSX from "xlsx";

const previewTableData = [
  {
    id: 0,
    col1: "BANKSESSXXXX",
    col2: "I103BANKNO2XXXXN",
    col3: "SEPA, MNO987123654",
    col4: "",
    col20: "REF987123654",
    col23B: "CRED",
    col32A: "240303SEK3000",
    col50A: "/9871236540 OLIVER ERICSON",
    col57A: "BANKNO2X",
    col59: "/5566778899 HENRY JOHNSTON",
    col70: "HOUSE RENT",
    col71A: "SHA",
    col72: "/INS/SAME DAY PROCESSING",
  },
  {
    id: 1,
    col1: "BANKFIHHXXXX",
    col2: "I103BANKDKKKXXXXN",
    col3: "SEPA, PQR456789123",
    col4: "",
    col20: "REF456789123",
    col23B: "CRED",
    col32A: "240303SEK5000",
    col50A: "/4567891230 EMMA WILSON",
    col57A: "BANKDKKKX",
    col59: "/1122334455 JAMES BROWN",
    col70: "CAR LOAN",
    col71A: "SHA",
    col72: "/INS/SAME DAY PROCESSING",
  },
  {
    id: 2,
    col1: "BANKPTPLXXXX",
    col2: "I103BANKGRXXXXXXN",
    col3: "SEPA, STU654321987",
    col4: "",
    col20: "REF654321987",
    col23B: "CRED",
    col32A: "240303SEK7000",
    col50A: "/6543219870 LUCAS MARTIN",
    col57A: "BANKGRXXX",
    col59: "/9988776655 SARAH DAVIS",
    col70: "HOME RENOVATION",
    col71A: "SHA",
    col72: "/INS/SAME DAY PROCESSING",
  },
  {
    id: 3,
    col1: "BANKESPBXXXX",
    col2: "I103BANKITRRXXXXN",
    col3: "SEPA, VWX321654987",
    col4: "",
    col20: "REF321654987",
    col23B: "CRED",
    col32A: "240303SEK4000",
    col50A: "/3216549870 SOPHIA LEE",
    col57A: "BANKITRRX",
    col59: "/4455667788 MICHAEL WHITE",
    col70: "EDUCATION",
    col71A: "SHA",
    col72: "/INS/SAME DAY PROCESSING",
  },
  {
    id: 4,
    col1: "BANKDEFFXXXX",
    col2: "I103BANKFRXXXXXXN",
    col3: "SEPA, YZA987654321",
    col4: "",
    col20: "REF987654321",
    col23B: "CRED",
    col32A: "240303SEK6000",
    col50A: "/9876543210 THOMAS CLARK",
    col57A: "BANKFRXXX",
    col59: "/6677889900 LUCY ADAMS",
    col70: "BUSINESS EXPENSE",
    col71A: "SHA",
    col72: "/INS/SAME DAY PROCESSING",
  },
];

const fileNames = {
  OFAC: ["ofac-23-04-2025-120000_processed.pdf"],
  PEP: ["pep-23-04-2025-120000_processed.pdf"],
  "UK sanctions": ["uk-sanctions-23-04-2025-120000_processed.pdf"],
  "NON SDN": ["non-sdn-23-04-2025-120000_processed.pdf"],
  "Grey List": ["grey-list-23-04-2025-120000_processed.pdf"],
  "White List": ["white-list-23-04-2025-120000_processed.pdf"],
};

const History = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const themeColor = "var(--theme-color)";

    const handleViewClick = (file) => {
        setSelectedFile(file);
    };

    const handleDownloadClick = (file) => {
        const ws = XLSX.utils.json_to_sheet(previewTableData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Table Data");
        XLSX.writeFile(wb, `${file}.xlsx`);
    };

    return (
        <div className="efficiency-page">
        <div className="page-container">
                <div className="row justify-content-between">
                    <div className="col-12 col-md-4">
                        <h5 className="mb-4">Historical Data</h5>
                    </div>
                </div>
                <div>
                    <table size="small" className="table table-bordered table-striped">
                        <thead className="table-dark">
                        <tr>
                            <th>File Name</th>
                            <th>Load Date</th>
                            <th>End Date</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {Object.entries(fileNames).map(([type, files]) =>
                            files.map((file, index) => (
                            <tr key={`${type}-${index}`}>
                                <td>{file}</td>
                                <td>23-04-2025</td>
                                <td>23-04-2025</td>
                                <td>
                                <IconButton
                                    style={{ color: themeColor }}
                                    onClick={() => handleViewClick(file)}
                                    size="small"
                                >
                                    <MdVisibility />
                                </IconButton>
                                <IconButton
                                    style={{ color: themeColor }}
                                    onClick={() => handleDownloadClick(file)}
                                    size="small"
                                >
                                    <MdDownload />
                                </IconButton>
                                </td>
                            </tr>
                            ))
                        )}
                        </tbody>
                    </table>
                </div>

                {selectedFile && (
                <div className="card mt-4 p-3">
                    <div className="row justify-content-between align-items-center mb-3">
                            <div className="col-auto">
                            <h6>Preview - {selectedFile}</h6>
                            </div>
                            {/* <div className="col-auto">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleDownloadClick(selectedFile)}
                            >
                                Download
                            </Button>
                            </div> */}
                    </div>
                    <div className="table-responsive">
                            <table
                            id="fileTable"
                            className="table table-bordered table-striped"
                            >
                            <thead className="table-dark">
                                <tr>
                                <th>#</th>
                                <th>1:</th>
                                <th>2:</th>
                                <th>3:</th>
                                <th>4:</th>
                                <th>:20:</th>
                                <th>:23B:</th>
                                <th>:32A:</th>
                                <th>:50A:</th>
                                <th>:57A:</th>
                                <th>:59:</th>
                                <th>:70:</th>
                                <th>:71A:</th>
                                <th>:72:</th>
                                </tr>
                            </thead>
                            <tbody>
                                {previewTableData.map((row, index) => (
                                <tr key={row.id}>
                                    <td>{index + 1}</td>
                                    <td>{row.col1}</td>
                                    <td>{row.col2}</td>
                                    <td>{row.col3}</td>
                                    <td>{row.col4}</td>
                                    <td>{row.col20}</td>
                                    <td>{row.col23B}</td>
                                    <td>{row.col32A}</td>
                                    <td>{row.col50A}</td>
                                    <td>{row.col57A}</td>
                                    <td>{row.col59}</td>
                                    <td>{row.col70}</td>
                                    <td>{row.col71A}</td>
                                    <td>{row.col72}</td>
                                </tr>
                                ))}
                            </tbody>
                            </table>
                    </div>
                </div>
                )}
            </div>
        </div>
    );
};

export default History;
